import * as React from "react";
import { withRouter } from "react-router-dom";
import logoBG from "../../assets/images/logos/overgas-direct-logo.png";
import logoEN from "../../assets/images/logos/overgas-direct-logo-en.png";
import demoEN from "../../assets/images/logos/gasified-admin-logo.png";
import UserMenuComponent from '../../components/profile/userMenu';
import Language from '../../components/language/language';
import { Link } from "react-router-dom";
import Translate from '../../common/functions/translate';
import { connect } from 'react-redux';
import * as Constants from "../../common/constants";

interface Iprops {
  lang: string;
}

interface IState {

}

class HeaderComponent extends React.Component<Iprops, IState> {
  public render() {
    return (
      <header className="app-header">
        <div className="app-logo-wrap">
          <Link to="/">
            {
              Constants.envName === 'Demo-EN' ?
                <img src={demoEN} className="app-logo" alt="logo" /> :
                <img src={this.props.lang === "bg" ? logoBG : logoEN} className="app-logo" alt="logo" />
            }
          </Link>
          <div className="app-title">{Translate("Administration")}</div>
          <span style={{ marginLeft: "10px" }}>{Constants.envName !== "Production" ? Constants.envName : null}</span>
        </div>
        <div className="app-header-right">
          <UserMenuComponent></UserMenuComponent>
          <Language></Language>
        </div>
      </header>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default withRouter(connect(mapsStateToProps, null)(HeaderComponent));